import { render, staticRenderFns } from "./SectionStatusComponent.vue?vue&type=template&id=0705d7fa&"
import script from "./SectionStatusComponent.vue?vue&type=script&lang=ts&"
export * from "./SectionStatusComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0705d7fa')) {
      api.createRecord('0705d7fa', component.options)
    } else {
      api.reload('0705d7fa', component.options)
    }
    module.hot.accept("./SectionStatusComponent.vue?vue&type=template&id=0705d7fa&", function () {
      api.rerender('0705d7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Applicant/SectionStatusComponent.vue"
export default component.exports